import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const stepNames = [
  'Organization',
  'Division',
  'Department',
  'Position',
  'Working Calendar',
  'Organization Chart',
];

export default function SetupModuleBanner() {
  const navigate = useNavigate();
  const returnTo = sessionStorage.getItem('workplansiq.workspaceSetupReturnTo');
  const activeStep = Number(sessionStorage.getItem('workplansiq.workspaceSetupActiveStep'));

  if (!returnTo || !Number.isInteger(activeStep) || activeStep < 0 || activeStep >= stepNames.length) return null;

  const returnToSetup = () => {
    sessionStorage.removeItem('workplansiq.workspaceSetupReturnTo');
    sessionStorage.removeItem('workplansiq.workspaceSetupActiveStep');
    navigate(returnTo);
  };

  return (
    <div className="setup-module-banner" role="status">
      <div>
        <strong>Initial Setup - {stepNames[activeStep]}</strong>
        <span>Review or update this module, then return to Initial Setup to continue.</span>
      </div>
      <Button icon={<ArrowLeftOutlined />} onClick={returnToSetup}>Back to Initial Setup</Button>
    </div>
  );
}
